<template>
  <v-data-table :loading="loading" :loader-height="5" :items="filteredRecordEntries" :headers="tableHeader"
                sort-by="createdAt" sort-desc>
    <template v-slot:body.prepend>
      <tr>
        <td v-for="header in tableHeader" :key="`filter-${header.value}`" class="pa-1">
          <v-select
              v-if="header.value === 'type'"
              v-model="recordEntryColumnFilters[header.value]"
              :items="recordEntryTypeFilterOptions"
              dense
              outlined
              hide-details
              clearable
              placeholder="Art auswählen"
          />
          <v-text-field
              v-else
              v-model="recordEntryColumnFilters[header.value]"
              dense
              outlined
              hide-details
              clearable
              :placeholder="`Suche ${header.text}`"
          />
        </td>
      </tr>
    </template>

    <template v-slot:item.createdAt="{ item }">
      {{ formatDate(item.createdAt) }}
    </template>

    <template v-slot:item.createdBy="{ item }">
        <span v-if="item.createdBy">
          <user-avatar :size="24" :user-obj="item.createdBy" cache class="mr-2"/>
          {{ item.createdBy.displayName }}
        </span>
      <span v-else>System</span>
    </template>

    <template v-slot:item.type="{ item }">
      {{ companyRecordEntryTypes[item.type] || item.type }}
    </template>

    <template v-slot:item.fine="{ item }">
      {{ formatMoney(item.fine || 0) }}
    </template>

    <template v-slot:item.actions="{ item }">
      <v-btn icon :to="'/company/' + item.id">
        <v-icon color="primary">mdi-eye-outline</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>
<script>
import {COMPANY_RECORD_ENTRY_TYPES} from "@/plugins/config";
import moment                                      from "moment";
import UserAvatar      from "@/components/UserAvatar.vue";

export default {
  components: {UserAvatar},
  data:       () => ({
    loading:       true,
    recordEntries: [],

    tableHeader: [
      {value: 'company.name', text: 'Unternehmen'},
      {value: 'type', text: 'Art'},
      {value: 'createdBy', text: 'Ersteller'},
      {value: 'fine', text: 'Betrag (in EUR)'},
      {value: 'createdAt', text: 'Erstelldatum'},
    ],

    recordEntryColumnFilters: {
      'company.name': '',
      type:           '',
      createdBy:      '',
      fine:           '',
      createdAt:      '',
    },
  }),
  computed:   {
    companyRecordEntryTypes() {
      return COMPANY_RECORD_ENTRY_TYPES;
    },
    recordEntryTypeFilterOptions() {
      return [...new Set(this.recordEntries.map((entry) => this.companyRecordEntryTypes[entry.type] || entry.type))];
    },
    filteredRecordEntries() {
      return this.recordEntries.filter((entry) => {
        return Object.entries(this.recordEntryColumnFilters).every(([column, searchTerm]) => {
          const normalizedSearch = this.normalizeFilterValue(searchTerm);
          if (!normalizedSearch) {
            return true;
          }

          const columnValue = this.getRecordEntryColumnValue(entry, column);

          if (column === 'type') {
            return this.normalizeFilterValue(columnValue) === normalizedSearch;
          }

          return this.normalizeFilterValue(columnValue).includes(normalizedSearch);
        });
      });
    }
  },
  methods:    {
    normalizeFilterValue(value) {
      if (value === null || value === undefined) {
        return '';
      }

      return String(value).toLowerCase().trim();
    },
    getRecordEntryColumnValue(entry, column) {
      switch (column) {
        case 'type':
          return this.companyRecordEntryTypes[entry.type] || entry.type;
        case 'createdBy':
          return entry.createdBy ? entry.createdBy.displayName : 'System';
        case 'fine':
          return this.formatMoney(entry.fine || 0);
        case 'createdAt':
          return this.formatDate(entry.createdAt);
        default:
          return this.getNestedValue(entry, column);
      }
    },
    getNestedValue(sourceObject, path) {
      return path.split('.').reduce((currentValue, pathPart) => {
        if (currentValue === null || currentValue === undefined) {
          return '';
        }
        return currentValue[pathPart];
      }, sourceObject);
    },
    formatDate(date) {
      return moment(date).format("D.MM.YYYY HH:mm:ss");
    }
  },
  mounted() {
    this.loading = true;
    this.apiGetTopCompanyRecordEntries().then(r => {
      this.recordEntries = r.data;
      this.loading       = false;
    })
  }
}
</script>